import { useState } from "react";
import MatchCardMainRow from "./MatchCardMainRow";
import RecordResultForm from "./RecordResultForm";

/**
 * A single match row in the admin Results panel. Shows summary + inline expandable
 * form to record / edit a result. Shares the same visual language across all three
 * panel sections (live, scheduled, completed).
 */
export default function MatchCard({ match, players, onRefresh, onReschedule, onShare }) {
  const [expanded, setExpanded] = useState(false);

  const p1 = players.find((p) => p.id === match.player1_id);
  const p2 = players.find((p) => p.id === match.player2_id);
  const p1Name = match.player1_name || p1?.name || "TBD";
  const p2Name = match.player2_name || p2?.name || "TBD";

  const isCompleted = match.status === "completed" || match.status === "walkover";
  const isLive = match.status === "live";
  const isScheduled = match.status === "scheduled";
  const canRecord = isScheduled || isCompleted;

  const statusBorder = isCompleted
    ? "border-l-primary bg-primary/5"
    : isLive
    ? "border-l-secondary bg-secondary/5"
    : "border-l-muted-foreground/30 bg-card";

  return (
    <div
      className={`border-l-4 rounded-lg border border-border ${statusBorder} transition-all`}
      data-testid={`match-card-${match.id}`}
    >
      <MatchCardMainRow
        match={match}
        p1Name={p1Name}
        p2Name={p2Name}
        isCompleted={isCompleted}
        isLive={isLive}
        isScheduled={isScheduled}
        canRecord={canRecord}
        expanded={expanded}
        onToggleExpand={() => setExpanded((v) => !v)}
        onReschedule={onReschedule}
        onShare={onShare}
      />
      {expanded && canRecord && (
        <RecordResultForm
          match={match}
          p1Name={p1Name}
          p2Name={p2Name}
          isCompleted={isCompleted}
          isScheduled={isScheduled}
          onRefresh={onRefresh}
          onClose={() => setExpanded(false)}
        />
      )}
    </div>
  );
}
